import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AuthenticationService } from 'src/app/_services'
import jsPDF from 'jspdf'
import domtoimage from 'dom-to-image'
import { environment } from 'src/environments/environment'
import * as pdfMake from 'pdfMake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
import { NgxSpinnerService } from 'ngx-spinner'
declare var require: any
const htmlToPdfmake = require('html-to-pdfmake')
;(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs
@Component({
  selector: 'app-pdf-bill-of-lading',
  templateUrl: './pdf-bill-of-lading.component.html',
  styleUrls: ['./pdf-bill-of-lading.component.css']
})
export class PdfBillOfLadingComponent implements OnInit {
  arrrayHoja4 = []
  arrayweight = []
  hoja2 = []
  Quantity = 0
  InfoCompany = []
  sumaweight = 0
  hoja1v = true
  hoja2v = false
  hoja3v = false
  tr1 = false
  tr2 = false
  tr3 = false
  tr4 = false
  tr5 = false
  @ViewChild('pdfTable2')
  pdfTable2!: ElementRef
  @ViewChild('pdfTable3')
  pdfTable3!: ElementRef
  isLDT=false;
  labelpaginar3=''
  poNumberView=true;
  constructor (
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private auten: AuthenticationService,
    public dialogRef: MatDialogRef<PdfBillOfLadingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.InfoCompany = []
    this.hoja2 = []
    this.arrayweight = []
    this.arrrayHoja4 = []
    this.OnInfoCompany()
    try {
      for (let index = 0; index < this.data.items.length; index++) {
        const element = this.data.items[index]
        this.OnSumWeight(element.id)
      }
      for (let index = 0; index < this.data.billoflading.length; index++) {
        const element = this.data.billoflading[index]
        this.arrrayHoja4.push(element)
        try {
          this.Quantity += element.TotalPallet * element.Quantity
        } catch (error) {}
      }
    } catch (error) {}


    if (this.auten.currentUserValue.company=='LDT20') {
      this.isLDT=true;
      this.labelpaginar3='2'
    }else{
      this.hoja2v=true;

      this.labelpaginar3='3'
    }

   
  }

  onNoClick (): void {
    this.dialogRef.close()
  }

  ngOnInit (): void {
    console.log(this.data)
    if (Number(this.data.orderData.tblCustomerID)==1264) {
      this.poNumberView=false;
    } else if (Number(this.data.orderData.tblCustomerID)==1265) {
      this.poNumberView=false;
    }else{
      this.poNumberView=true;

    }
    try {
      var to=this.arrrayHoja4.length
      var p=32-to

      
      for (let index = 0; index <p; index++) {
        const element = {
          TotalPallet: 0,
          ItemNumber: '',
          Description: '',
          miscnumber: '',
          palletcount: 0,
          Location: '',
          Quantity: 0,
          nmfc_product: '',
          class_product: '',
          weight: 0,
          type: ''
        }

        this.arrrayHoja4.push(element)
      }
      console.log(this.arrrayHoja4,p)
    } catch (error) {}

    try {
      this.tr1 = false
      this.tr2 = false
      this.tr3 = false
      this.tr4 = false
      this.tr5 = false

      var total = this.data.billoflading.length

      if (total == 1) {
        this.tr1 = true
        this.tr2 = true
        this.tr3 = true
        this.tr4 = true
        this.tr5 = true
      } else if (total == 2) {
        this.tr3 = true
        this.tr4 = true
        this.tr5 = true
      } else if (total == 3) {
        this.tr4 = true
        this.tr5 = true
      } else if (total == 4) {
        this.tr5 = true
      } else if (total == 5) {
        this.tr1 = false
        this.tr2 = false
        this.tr3 = false
        this.tr4 = false
        this.tr5 = false
      }
    } catch (error) {}

    this.onsegundapagina()
  }

  OnSumWeight (item: number) {
    this.http
      .get<any>(
        `${environment.apiUrl}/Shipping/SumWeightPalletsBillofLading?OrderId=${item}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + this.auten.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.sumaweight += response[0].weight_pllets
          var js = {
            itemID: item,
            weight: response[0].weight_pllets
          }

          this.arrayweight.push(js)
        } catch (error) {}
      })
  }
  OnInfoCompany () {
    if (this.data.orderData.tblCustomerID==1264) {
      var j={
        "ID":0,
        "Company_Name":"Pentair Pool (MOORPARK) C/O Line Drive (Anaheim)",
        "Contact_Name":"",
        "Address":"1231 N MILLER st",
        "Address1":"",
        "City":"ANAHEIM",
        "State":"CA",
        "Zip":"92806",
        "Phone":"800-899-0668",
        "Fax":"",
        "Email":"LINEDRIVEHELP@LINEDRIVETRUCKING.COM",
        "Logo":"https:\/\/cdn.3plfreightsoftware.com\/cdn\/logos\/LDT20.png",
        "Admin_License":20,
        "Partner_License":20,
        "Client_License":20,
        "Active":true,
        "Company_Website":"https:\/\/linedrivetrucking.com",
        "PaymentBTN":50,
        "Date_Created":"2020-11-19T04:17:00"
     }
      this.InfoCompany.push(j)
    }else  if (this.data.orderData.tblCustomerID==1265) {
      var j={
        "ID":0,
        "Company_Name":"Pentair Water (CHINO) C/O Line Drive (Anaheim)",
        "Contact_Name":"",
        "Address":"1231 N MILLER st",
        "Address1":"",
        "City":"ANAHEIM",
        "State":"CA",
        "Zip":"92806",
        "Phone":"800-899-0668",
        "Fax":"",
        "Email":"LINEDRIVEHELP@LINEDRIVETRUCKING.COM",
        "Logo":"https:\/\/cdn.3plfreightsoftware.com\/cdn\/logos\/LDT20.png",
        "Admin_License":20,
        "Partner_License":20,
        "Client_License":20,
        "Active":true,
        "Company_Website":"https:\/\/linedrivetrucking.com",
        "PaymentBTN":50,
        "Date_Created":"2020-11-19T04:17:00"
     }
      this.InfoCompany.push(j)
    }else  if (this.data.orderData.tblCustomerID==355) {
      var j={
        "ID":0,
        "Company_Name":"AMERICAL %LINE DRIVE",
        "Contact_Name":"",
        "Address":"1231 N MILLER st #150",
        "Address1":"",
        "City":"ANAHEIM",
        "State":"CA",
        "Zip":"92806",
        "Phone":"800-899-0668",
        "Fax":"",
        "Email":"LINEDRIVEHELP@LINEDRIVETRUCKING.COM",
        "Logo":"https:\/\/cdn.3plfreightsoftware.com\/cdn\/logos\/LDT20.png",
        "Admin_License":20,
        "Partner_License":20,
        "Client_License":20,
        "Active":true,
        "Company_Website":"https:\/\/linedrivetrucking.com",
        "PaymentBTN":50,
        "Date_Created":"2020-11-19T04:17:00"
     }
      this.InfoCompany.push(j)
    }else  if (this.data.orderData.tblCustomerID==1169) {
      var j={
        "ID":0,
        "Company_Name":"BINCELLAR %LINE DRIVE",
        "Contact_Name":"",
        "Address":"1231 N MILLER st #150",
        "Address1":"",
        "City":"ANAHEIM",
        "State":"CA",
        "Zip":"92806",
        "Phone":"800-899-0668",
        "Fax":"",
        "Email":"LINEDRIVEHELP@LINEDRIVETRUCKING.COM",
        "Logo":"https:\/\/cdn.3plfreightsoftware.com\/cdn\/logos\/LDT20.png",
        "Admin_License":20,
        "Partner_License":20,
        "Client_License":20,
        "Active":true,
        "Company_Website":"https:\/\/linedrivetrucking.com",
        "PaymentBTN":50,
        "Date_Created":"2020-11-19T04:17:00"
     }
      this.InfoCompany.push(j)
    }else  if (this.data.orderData.tblCustomerID==1190) {
      var j={
        "ID":0,
        "Company_Name":"COMPLETE SOLAR %LINE DRIVE",
        "Contact_Name":"",
        "Address":"1231 N MILLER st #150",
        "Address1":"",
        "City":"ANAHEIM",
        "State":"CA",
        "Zip":"92806",
        "Phone":"800-899-0668",
        "Fax":"",
        "Email":"LINEDRIVEHELP@LINEDRIVETRUCKING.COM",
        "Logo":"https:\/\/cdn.3plfreightsoftware.com\/cdn\/logos\/LDT20.png",
        "Admin_License":20,
        "Partner_License":20,
        "Client_License":20,
        "Active":true,
        "Company_Website":"https:\/\/linedrivetrucking.com",
        "PaymentBTN":50,
        "Date_Created":"2020-11-19T04:17:00"
     }
      this.InfoCompany.push(j)
    }else  if (this.data.orderData.tblCustomerID==379) {
      var j={
        "ID":0,
        "Company_Name":"KINGFA %LINE DRIVE",
        "Contact_Name":"",
        "Address":"1231 N MILLER st #150",
        "Address1":"",
        "City":"ANAHEIM",
        "State":"CA",
        "Zip":"92806",
        "Phone":"800-899-0668",
        "Fax":"",
        "Email":"LINEDRIVEHELP@LINEDRIVETRUCKING.COM",
        "Logo":"https:\/\/cdn.3plfreightsoftware.com\/cdn\/logos\/LDT20.png",
        "Admin_License":20,
        "Partner_License":20,
        "Client_License":20,
        "Active":true,
        "Company_Website":"https:\/\/linedrivetrucking.com",
        "PaymentBTN":50,
        "Date_Created":"2020-11-19T04:17:00"
     }
      this.InfoCompany.push(j)
    }else  if (this.data.orderData.tblCustomerID==1266) {
      var j={
        "ID":0,
        "Company_Name":"WIELAND %LINE DRIVE",
        "Contact_Name":"",
        "Address":"1231 N MILLER st #150",
        "Address1":"",
        "City":"ANAHEIM",
        "State":"CA",
        "Zip":"92806",
        "Phone":"800-899-0668",
        "Fax":"",
        "Email":"LINEDRIVEHELP@LINEDRIVETRUCKING.COM",
        "Logo":"https:\/\/cdn.3plfreightsoftware.com\/cdn\/logos\/LDT20.png",
        "Admin_License":20,
        "Partner_License":20,
        "Client_License":20,
        "Active":true,
        "Company_Website":"https:\/\/linedrivetrucking.com",
        "PaymentBTN":50,
        "Date_Created":"2020-11-19T04:17:00"
     }
      this.InfoCompany.push(j)
    } else{
    this.http
      .get<any>(
        `${environment.apiUrl}/Shipping/CompanyInfoBillofLading?tblCompanyID=${this.auten.currentUserValue.companyIdWh}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + this.auten.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.InfoCompany = response
      })
    }
  }

  onsegundapagina () {
    try {
      var total = this.data.items.length

      for (let index = 0; index < this.data.items.length; index++) {
        const element = this.data.items[index]
        this.hoja2.push(element)
      }
      if (total < 33) {
        var ite = 33 - total
        console.log(ite, 'entro')

        for (let index = 0; index < ite; index++) {
          const element = {
            id: 0,
            ItemNumber: '',
            Description: '',
            miscnumber: '',
            palletcount: 0,
            Location: '',
            Quantity: 0
          }
          this.hoja2.push(element)
        }
      }

      console.log(this.hoja2)
    } catch (error) {}
  }
  onHoja2 (hoja: number) {
    this.hoja1v = false
    this.hoja2v = false
    this.hoja3v = false
    if (hoja == 1) {
      this.hoja1v = true
    } else if (hoja == 2) {
      this.hoja2v = true
    } else {
      this.hoja3v = true
    }
  }
  filterWeight (locationName: number) {
    return this.arrayweight.filter(object => {
      if (object.itemID == locationName) {
        return object
      }
    })
  }

  onSearchWeight (item: number) {
    var txt = ''
    var wei = this.filterWeight(item)
    try {
      txt = wei[0].weight
    } catch (error) {
      txt = ''
    }

    return txt
  }
  @ViewChild('pdfTable')
  pdfTable!: ElementRef

  public downloadAsPDF () {
    const pdfTable = this.pdfTable.nativeElement
    var html = htmlToPdfmake(pdfTable.innerHTML, {
      removeExtraBlanks: true,
      tableAutoSize: true
    })
    const documentDefinition = { content: html }
    pdfMake.createPdf(documentDefinition).download()
  }
  onp () {
    let div = this.pdfTable.nativeElement
    let div2 ;
    let div3 = this.pdfTable3.nativeElement
if (this.auten.currentUserValue.company=="LDT20") {

} else {
  div2  = this.pdfTable2.nativeElement
}
    var img: any
    var filename
    var newImage: any
    var img2: any
    var filename2
    var newImage2: any
    var img3: any
    var filename3
    var newImage3: any
    var doc
    this.spinner.show()

    domtoimage
      .toPng(div, { bgcolor: '#fff' })

      .then(function (dataUrl) {
        img = new Image(865,1400)
        img.src = dataUrl
        newImage = img.src
        

        img.onload = function () {
          var pdfWidth = img.width
          var pdfHeight = img.height

          // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image
          doc = new jsPDF('p', 'mm', 'a4',true);

          var width = doc.internal.pageSize.getWidth()
          var height = doc.internal.pageSize.getHeight()
          console.log( width, height)

          doc.addImage(newImage, 'JPEG', 20,20, 175, 250)
          filename = 'BILL-OF-LADING-PAGE-1' + '.pdf'
          // doc.save(filename);
        }
      })
      .catch(function (error) {
        // Error Handling
      })


      if (this.auten.currentUserValue.company=='LDT20') {
    
      }else{
        setTimeout(() => {
          domtoimage
            .toPng(div2, { bgcolor: '#fff' })
    
            .then(function (dataUrl) {
              img2 = new Image(865,1400)
              img2.src = dataUrl
              newImage2 = img2.src
    
              img2.onload = function () {
                var pdfWidth = img2.width
                var pdfHeight = img2.height
    
                // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image
    
                var width = doc.internal.pageSize.getWidth()
                var height = doc.internal.pageSize.getHeight()
                doc.addPage('p', 'mm', 'a4',true)
    
                doc.addImage(newImage2, 'JPEG',  10,15, 190, 250)
                filename = 'BILL-OF-LADING-PAGE-1' + '.pdf'
                //  doc.save(filename);
              }
            })
            .catch(function (error) {
              // Error Handling
            })
        }, 1200)
      }
   

    setTimeout(() => {
      domtoimage
        .toPng(div3, { bgcolor: '#fff' })

        .then(function (dataUrl) {
          img3 = new Image(865,1400)
          img3.src = dataUrl
          newImage3 = img3.src

          img3.onload = function () {
            var pdfWidth = img3.width
            var pdfHeight = img3.height

            // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image

            var width = doc.internal.pageSize.getWidth()
            var height = doc.internal.pageSize.getHeight()
            doc.addPage('p', 'mm', 'a4',true)

            doc.addImage(newImage3, 'JPEG',   10,20, 190, 250)
            filename = 'BILL-OF-LADING' + '.pdf'
            doc.autoPrint({variant: 'javascript'});
            doc.output('dataurlnewwindow');
            //doc.save(filename)
          }
        })
        .catch(function (error) {
          // Error Handling
        })
      setTimeout(() => {
        this.spinner.hide()
      }, 1200)
    }, 1200)

    // this opens a new popup,  after this the PDF opens the print window view but there are browser inconsistencies with how this is handled
  }
}
